import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Product } from 'src/features/types'
import Table from 'src/features/base/components/Table'
import { ScrollMessage } from 'src/features/base/components/Table/Table.styles'
import { NumberFmt } from 'src/utils'
import { selectHasNextPage, selectStock } from '../../StockListSelector'
import { actions } from '../../StockListState'
import columns from './StockTable.columns'

export default () => {
  const dispatch = useDispatch()
  const stock = useSelector(selectStock)
  const hasNext = useSelector(selectHasNextPage)
  const history = useHistory()

  const onRowDoubleClick = (_, tableRow) => ({
    onDoubleClick: () => {
      const { modelId, fulfillmentCenter }: Product = tableRow.original
      history.push(`/stock-managment/product/${fulfillmentCenter.id}/${modelId}`)
    },
  })

  const handleNextPage = () => {
    dispatch(actions.nextPage())
    dispatch(actions.getStock())
  }

  const prepareStockData = (stockData: Product[]) => stockData.map((stockRow) => (
    {
      ...stockRow,
      available: NumberFmt({ value: stockRow.available, sufix: '' }),
      total: NumberFmt({ value: stockRow.total, sufix: '' }),
      reserved: NumberFmt({ value: stockRow.reserved, sufix: '' }),
    }))

  return (
    <InfiniteScroll
      dataLength={stock.length}
      next={handleNextPage}
      hasMore={hasNext}
      loader={<ScrollMessage>Carregando mais dados</ScrollMessage>}
      endMessage={<ScrollMessage>Fim dos resultados</ScrollMessage>}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Table
        data={prepareStockData(stock)}
        columns={columns}
        onRowDoubleClick={onRowDoubleClick}
      />
    </InfiniteScroll>
  )
}
